import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              精选文章
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              编辑精选的高质量内容，带你深入了解好色小姨的文学世界
            </p>
          </div>
          <Link
            to="/category/renwu-fenxi"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.slice(0, 6).map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}